import { render, staticRenderFns } from "./IconHandSolid.vue?vue&type=template&id=27b9d9d0"
import script from "./IconHandSolid.vue?vue&type=script&lang=js"
export * from "./IconHandSolid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports